import { sendEvent } from "./metrics/events";

const MODAL_CONTAINER_ID = "__modal_container";
const MODAL_CONTAINER = `<div x-data id="${MODAL_CONTAINER_ID}" x-bind="$store.modal.shared_container()" class="relative w-auto h-auto"></div>`;

function createModalContainer() {
  const el = document.createElement("div");
  el.innerHTML = MODAL_CONTAINER;
  document.body.appendChild(el.firstElementChild);
}

document.addEventListener("alpine:init", () => {
  createModalContainer();

  if (history.state?.modalName) {
    const cleanState = { ...history.state };
    delete cleanState.modalName;
    history.replaceState(cleanState, "");
  }

  Alpine.store("modal", {
    _open: [],

    isOpen(name = "") {
      return this._open.includes(name);
    },

    isUpModal(name = "") {
      return this._open[this._open.length - 1] === name;
    },

    open(name = "", metricsId = "", fromPopstate = false) {
      if (!name || this.isOpen(name)) return;

      this._open.push(name);

      if (!fromPopstate) {
        history.pushState({ ...history.state, modalName: name }, "");
        metricsId && sendEvent("popup", metricsId);
      }
    },

    close(name = "", fromPopstate = false) {
      const targetName = name || this._open[this._open.length - 1];
      if (!targetName) return;

      const index = this._open.lastIndexOf(targetName);
      if (index === -1) return;

      if (!fromPopstate && this.isUpModal(targetName)) {
        if (history.state?.modalName === targetName) {
          history.back();
          return;
        }
      }

      this._open.splice(index, 1);
    },

    shared_container() {
      const extThis = this;
      return {
        "@keydown.escape.window"() {
          extThis.close();
        },
        "@popstate.window"(event) {
          const stateName = event.state?.modalName;

          if (stateName && !extThis.isOpen(stateName)) {
            extThis.open(stateName, "", true);
          } else {
            if (extThis._open.length > 0) {
              const isSwipe = event.hasUAVisualTransition === true;
              if (isSwipe) {
                const prevName = extThis._open[extThis._open.length - 1];
                document
                  .querySelectorAll(`[data-container-name="modal-container-${prevName}"]`)
                  .forEach((x) => (x.style.display = "none"));
              }
              extThis.close("", true);
            }
          }
        },
      };
    },

    container(name, disableAnimation = false) {
      const extThis = this;
      const animationParams = !disableAnimation
        ? {
            "x-transition:enter": "transition-opacity ease-out duration-300 ",
            "x-transition:enter-start": "opacity-0",
            "x-transition:enter-end": "opacity-100",
            "x-transition:leave": "transition ease-in duration-300 ",
            "x-transition:leave-start": "opacity-100",
            "x-transition:leave-end": "opacity-0",
          }
        : {};
      return {
        "x-show"() {
          return extThis.isOpen(name);
        },
        ":data-container-name"() {
          return extThis.isOpen(name) ? `modal-container-${name}` : "";
        },

        "@click.self.prevent"() {
          extThis.isOpen(name) && extThis.close(name);
        },
        "x-cloak": true,
        ":class"() {
          return {
            "z-9999": extThis.isUpModal(name),
            "z-50": !extThis.isUpModal(name),
          };
        },
        ...animationParams,
      };
    },
    wrapper(name, disableAnimation = false) {
      const extThis = this;
      const animationParams = !disableAnimation
        ? {
            "x-transition:enter": "transition ease-out duration-300 will-change-transform",
            "x-transition:enter-start": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
            "x-transition:enter-end": "opacity-100 translate-y-0 sm:scale-100",
            "x-transition:leave": "transition ease-in duration-300 will-change-transform ",
            "x-transition:leave-start": "opacity-100 translate-y-0 sm:scale-100",
            "x-transition:leave-end": "opacity-0 translate-y-8 sm:translate-y-0 sm:scale-95",
            ":class"() {
              return {
                "translate-y-0": extThis.isOpen(name),
              };
            },
          }
        : {};
      return {
        "x-show"() {
          return extThis.isOpen(name);
        },
        "x-trap.inert.noscroll"() {
          return extThis.isOpen(name);
        },
        "x-cloak": true,
        ...animationParams,
      };
    },
    template: {
      "x-teleport": `#${MODAL_CONTAINER_ID}`,
    },
  });
});
